import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "caret-icon-svg": "pbui-28E0-",
  "clear-icon": "pbui-YWhCJ",
  "clear-icon-svg": "pbui-tYnTW",
  "label": "pbui-ufffz"
};
export var SelectLabel = function SelectLabel(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("label", _extends({
    className: styles.label
  }, rest, {
    children: children
  }));
};